import { Link } from "react-router-dom";
import type { Post } from "@/content/posts";
import { Clock } from "lucide-react";

const PostCard = ({ post, featured = false }: { post: Post; featured?: boolean }) => {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className={`group block rounded-2xl overflow-hidden border border-border bg-card hover:border-primary/40 transition-all ${
        featured ? "md:flex md:flex-row md:items-stretch" : ""
      }`}
    >
      <div className={`aspect-[16/9] overflow-hidden ${featured ? "md:w-2/3 md:aspect-auto" : ""}`}>
        <img
          src={post.cover}
          alt={post.title}
          width={1600}
          height={900}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={`p-5 md:p-6 flex flex-col gap-3 ${featured ? "md:w-1/3 md:justify-center" : ""}`}>
        <span className="text-[11px] uppercase tracking-widest text-primary font-semibold">
          {post.category === "brokers" ? "Brokers" : "AI Investing"}
        </span>
        <h2 className={`font-bold text-foreground group-hover:text-primary transition ${featured ? "text-2xl md:text-3xl" : "text-lg"}`}>
          {post.title}
        </h2>
        <p className="text-sm text-foreground/65 leading-relaxed line-clamp-3">
          {post.description}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground/55 mt-1">
          <Clock className="w-3.5 h-3.5" />
          <span>{post.readingTime} min read</span>
          <span>·</span>
          <time dateTime={post.date}>
            {new Date(post.date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </time>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;
